import { batch } from 'react-redux';
import { AppThunk } from 'store';
import { getResponseError } from 'common/utils/index';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';

type TOperation = ({ cardNumber }: { cardNumber: string }) => AppThunk;

const { setActiveFuelCard } = slice.actions;
const { setError } = appSlice.actions;

const operation: TOperation =
  ({ cardNumber }) =>
  async (dispatch) => {
    try {
      batch(() => {
        dispatch(setActiveFuelCard(cardNumber));
      });
    } catch (e) {
      console.info(e);
      const error = await getResponseError(e);
      dispatch(setError(error));
    }
  };

export default operation;
